"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DIALOG_FULLSCREEN_DIALOG_SCROLLBAR_OFFSET: function() {
        return _constants.DIALOG_FULLSCREEN_DIALOG_SCROLLBAR_OFFSET;
    },
    DIALOG_MEDIA_QUERY_BREAKPOINT_SELECTOR: function() {
        return _constants.DIALOG_MEDIA_QUERY_BREAKPOINT_SELECTOR;
    },
    DIALOG_MEDIA_QUERY_SHORT_SCREEN: function() {
        return _constants.DIALOG_MEDIA_QUERY_SHORT_SCREEN;
    },
    Dialog: function() {
        return _Dialog.Dialog;
    },
    DialogActions: function() {
        return _DialogActions.DialogActions;
    },
    DialogBackdropProvider: function() {
        return _index.DialogBackdropProvider;
    },
    DialogBody: function() {
        return _DialogBody.DialogBody;
    },
    DialogContent: function() {
        return _DialogContent.DialogContent;
    },
    DialogProvider: function() {
        return _index.DialogProvider;
    },
    DialogSurface: function() {
        return _DialogSurface.DialogSurface;
    },
    DialogSurfaceProvider: function() {
        return _index.DialogSurfaceProvider;
    },
    DialogTitle: function() {
        return _DialogTitle.DialogTitle;
    },
    DialogTrigger: function() {
        return _DialogTrigger.DialogTrigger;
    },
    dialogActionsClassNames: function() {
        return _DialogActions.dialogActionsClassNames;
    },
    dialogBodyClassNames: function() {
        return _DialogBody.dialogBodyClassNames;
    },
    dialogContentClassNames: function() {
        return _DialogContent.dialogContentClassNames;
    },
    dialogSurfaceClassNames: function() {
        return _DialogSurface.dialogSurfaceClassNames;
    },
    dialogTitleClassNames: function() {
        return _DialogTitle.dialogTitleClassNames;
    },
    renderDialogActions_unstable: function() {
        return _DialogActions.renderDialogActions_unstable;
    },
    renderDialogBody_unstable: function() {
        return _DialogBody.renderDialogBody_unstable;
    },
    renderDialogContent_unstable: function() {
        return _DialogContent.renderDialogContent_unstable;
    },
    renderDialogSurface_unstable: function() {
        return _DialogSurface.renderDialogSurface_unstable;
    },
    renderDialogTitle_unstable: function() {
        return _DialogTitle.renderDialogTitle_unstable;
    },
    renderDialogTrigger_unstable: function() {
        return _DialogTrigger.renderDialogTrigger_unstable;
    },
    renderDialog_unstable: function() {
        return _Dialog.renderDialog_unstable;
    },
    useDialogActionsStyles_unstable: function() {
        return _DialogActions.useDialogActionsStyles_unstable;
    },
    useDialogActions_unstable: function() {
        return _DialogActions.useDialogActions_unstable;
    },
    useDialogBackdropContext_unstable: function() {
        return _index.useDialogBackdropContext_unstable;
    },
    useDialogBodyStyles_unstable: function() {
        return _DialogBody.useDialogBodyStyles_unstable;
    },
    useDialogBody_unstable: function() {
        return _DialogBody.useDialogBody_unstable;
    },
    useDialogContentStyles_unstable: function() {
        return _DialogContent.useDialogContentStyles_unstable;
    },
    useDialogContent_unstable: function() {
        return _DialogContent.useDialogContent_unstable;
    },
    useDialogContextValues_unstable: function() {
        return _Dialog.useDialogContextValues_unstable;
    },
    useDialogContext_unstable: function() {
        return _index.useDialogContext_unstable;
    },
    useDialogSurfaceContextValues_unstable: function() {
        return _DialogSurface.useDialogSurfaceContextValues_unstable;
    },
    useDialogSurfaceContext_unstable: function() {
        return _index.useDialogSurfaceContext_unstable;
    },
    useDialogSurfaceStyles_unstable: function() {
        return _DialogSurface.useDialogSurfaceStyles_unstable;
    },
    useDialogSurface_unstable: function() {
        return _DialogSurface.useDialogSurface_unstable;
    },
    useDialogTitleStyles_unstable: function() {
        return _DialogTitle.useDialogTitleStyles_unstable;
    },
    useDialogTitle_unstable: function() {
        return _DialogTitle.useDialogTitle_unstable;
    },
    useDialogTrigger_unstable: function() {
        return _DialogTrigger.useDialogTrigger_unstable;
    },
    useDialog_unstable: function() {
        return _Dialog.useDialog_unstable;
    }
});
const _Dialog = require("./Dialog");
const _DialogTrigger = require("./DialogTrigger");
const _DialogActions = require("./DialogActions");
const _DialogBody = require("./DialogBody");
const _DialogTitle = require("./DialogTitle");
const _DialogSurface = require("./DialogSurface");
const _DialogContent = require("./DialogContent");
const _index = require("./contexts/index");
const _constants = require("./contexts/constants");
